import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { computeFingerprint } from "./fingerprint"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getDeviceInfo() {
  if (typeof window === 'undefined') return undefined;

  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    deviceType: /mobile/i.test(navigator.userAgent)
      ? ('mobile' as const)
      : /tablet/i.test(navigator.userAgent)
        ? ('tablet' as const)
        : ('desktop' as const),
    fingerprint: computeFingerprint(),
  };
}
